<template>
  <div class="rs-ball-grid-pulse">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
  export default {
    name: 'RsBallGridPulse'
  }
</script>

<style lang="scss" scoped>
  $ball-size: 15px !default;
  $margin: 5px !default;

  @keyframes rs-ball-grid-pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.5);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  @mixin rs-ball-grid-pulse($n: 9) {
    @for $i from 1 through $n {
      > div:nth-child(#{$i}) {
        animation-delay: ((random(100) / 100) - 0.2) + s;
        animation-duration: ((random(100) / 100) + 0.6) + s;
      }
    }
  }

  .rs-ball-grid-pulse {
    @include rs-ball-grid-pulse();
    width: ($ball-size * 3) + $margin * 6;

    > div {
      width: $ball-size;
      height: $ball-size;
      border-radius: 100%;
      margin: $margin;
      background-color: var(--rs-accent-color);

      display: inline-block;
      float: left;
      animation-name: rs-ball-grid-pulse;
      animation-iteration-count: infinite;
      animation-delay: 0s;
      animation-fill-mode: both;
    }
  }
</style>
